// extracted by mini-css-extract-plugin
export default {"highlight":"Highlight_highlight__UJ7nA","icon":"Highlight_icon__DpPDy"};